import { render, staticRenderFns } from "./SaxxTextArea.vue?vue&type=template&id=03a1f29c"
import script from "./SaxxTextArea.vue?vue&type=script&lang=js"
export * from "./SaxxTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports